const Colors = {
  white: '#fff',
  blackText: '#212121',
  black: "#141312",
  darkGrayBlack:"#444444",
  lightGray: "#F7F7F7",
  lineGray: "#EEEEEE",
  textGray: "#898989",
  gray: "#9E9E9E",
  backgroundGray:'#E5E5E5',
  detailBackgroundGray: "#F2F2F2",
  buttonDarkGreen: '#80B213',
  labelLightGreen: '#A9D250',
  profileBackgroundGreen: 'rgba(169, 210, 80, 0.2)',
  statusOrange: '#F9C662',
  textOrange: '#EEBD5E',
}

export default Colors;
